module.exports = __webpack_public_path__ + "img/f3.28ee779a.png";